(function () {
  'use strict';
  var variants = window.SSBoxBundleVariants || {};
  var prints = window.SSBoxBundlePrints || {};
  function properties(item) {
    return Array.isArray(item.properties) ? Object.fromEntries(item.properties) : item.properties || {};
  }
  function prepare(item) {
    var mapping = variants[String(item.id)];
    if (!mapping) throw new Error('Could not prepare your box. Please refresh and try again.');
    var props = properties(item);
    var print = props['Print design'];
    if (!Object.prototype.hasOwnProperty.call(prints, print)) throw new Error('Please choose a print design for your box.');
    var selections = mapping.selections.slice();
    selections[mapping.printIndex] = print;
    return Object.assign({}, item, {
      id: mapping.parentVariant,
      properties: Object.assign({}, props, {
        _bundle_selection: selections.join(' <> '),
        _ss_source_variant: String(item.id)
      })
    });
  }
  function display(item) {
    var source = properties(item)._ss_source_variant;
    var mapping = variants[String(source)];
    if (!mapping || Number(item.variant_id || item.id) !== mapping.parentVariant) return item;
    return Object.assign({}, item, {
      handle: mapping.handle,
      variant_title: mapping.variantTitle,
      url: '/products/' + mapping.handle + '?variant=' + source
    });
  }
  function displayCart(cart) {
    return Object.assign({}, cart, { items: (cart.items || []).map(display) });
  }
  function needsMigration(cart) {
    return (cart.items || []).some(function(item) {
      return !!variants[String(item.variant_id || item.id)];
    });
  }
  function reconcile(cart) {
    if (!needsMigration(cart)) return Promise.resolve(cart);
    // Shopify has no atomic cart-line replacement; preserve older baskets for explicit re-selection.
    return Promise.reject(new Error('Please remove this box and add it again with your chosen print.'));
  }
  window.SSBoxBundles = { prepare: prepare, display: display, displayCart: displayCart, needsMigration: needsMigration, reconcile: reconcile };
})();
